// extracted by mini-css-extract-plugin
export default {"contactDetails":"F8F0ZeZpmmHV0FVpReAu"};